import { FilterValue } from 'models/FilterValue';
import { FilterValueWithChildren } from 'models/FilterValueWithChildren';
import { isFilterValueWithChildren } from 'components/Filter/utils';

const mapSelectedSubValuesToString = (filterValue: FilterValue | FilterValueWithChildren) => {
  return (
    isFilterValueWithChildren(filterValue) &&
    filterValue.subValues
      .filter(subValue => subValue.selected)
      .map(subValue => subValue.displayName)
      .join(', ')
  );
};

/**
 * Takes all filter values and returns a string of the selected filters.
 *
 * @param filterValues All filter values
 * @returns Comma seperated string with all the selected Filter Values
 */
export const mapSelectedFilterValuesToString = (
  filterValues: FilterValueWithChildren[] | FilterValue[]
) => {
  const selectedFilters = filterValues.filter(
    value =>
      value.selected ||
      (isFilterValueWithChildren(value) && value.subValues.some(subValue => subValue.selected))
  );

  const selectedFiltersString = selectedFilters
    .map(filterValue =>
      filterValue.selected ? filterValue.displayName : mapSelectedSubValuesToString(filterValue)
    )
    .join(', ');

  return selectedFiltersString;
};
